import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT, localStorageKeys } from "../const";

const mapBankResponse = (item = {}) => ({
  ...item,
  bnkId: item.bnkId ?? null,
  bnkCode: item.bnkCode ?? "",
  bnkName: item.bnkName ?? "",
  bnkDescription: item.bnkDescription ?? "",
  bnkCompany: item.bnkCompany ?? null,
  bnkStatus: item.bnkStatus ?? null,
  bnkActive: item.bnkActive ?? null,
});

const mapBankRequest = (data = {}) => ({
  bnkId: data.bnkId ?? null,
  bnkCode: data.bnkCode ? data.bnkCode : null,
  bnkName: data.bnkName ?? "",
  bnkDescription: data.bnkDescription ?? "",
  bnkCompany: data.bnkCompany ?? null,
  bnkStatus: data.bnkStatus ?? null,
  bnkActive: data.bnkActive ?? null,
  author: data.author ?? data.createdBy ?? data.lastModifiedBy ?? null,
});

export const bankDropdown = async (companyId) => {
  try {
    const activeCompanyId =
      companyId || localStorage.getItem(localStorageKeys?.USER?.CURRENT_COMPANY || "current_company");
    const url = activeCompanyId
      ? `${SERVICE_ENDPOINT.TRANSPORT}/bank?companyId=${activeCompanyId}`
      : `${SERVICE_ENDPOINT.TRANSPORT}/bank`;
    const response = await gatewayInstance.get(url);

    return response.data.map((item) => ({
      key: item.bnkId,
      text: item.bnkName || item.bnkDescription,
      value: item.bnkId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const createBank = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/bank`,
    mapBankRequest(data),
  );
  return response.data;
};

export const updateBank = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/bank`,
    mapBankRequest(data),
  );
  return response.data;
};

export const searchBanks = async (params = {}) => {
  const activeCompanyId =
    params.bnkCompany || localStorage.getItem(localStorageKeys?.USER?.CURRENT_COMPANY || "current_company");
  const payload = {
    ...params,
    bnkCompany: activeCompanyId ? Number(activeCompanyId) : (params.bnkCompany ?? null),
  };
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/bank/search`,
    payload,
  );

  return (response.data || []).map(mapBankResponse);
};

export const getBankById = async (id) => {
  const response = await gatewayInstance.get(
    `${SERVICE_ENDPOINT.TRANSPORT}/bank/${id}`,
  );

  return mapBankResponse(response.data);
};

export const bankContains = async (search, companyId) => {
  try {
    const activeCompanyId =
      companyId || localStorage.getItem(localStorageKeys?.USER?.CURRENT_COMPANY || "current_company");
    const url = activeCompanyId
      ? `${SERVICE_ENDPOINT.TRANSPORT}/banks/namecontains?companyId=${activeCompanyId}`
      : `${SERVICE_ENDPOINT.TRANSPORT}/banks/namecontains`;

    const searchPayload =
      typeof search === "object" && search !== null
        ? (search.searchText ?? "")
        : (search ?? "");

    const response = await gatewayInstance.post(
      url,
      searchPayload,
    );
    return (response.data || []).map((item) => ({
      key: item.id,
      title: item.code ? `[${item.code}] - ${item.text}` : (item.text || ""),
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const branchByBankAndContains = async ({searchText, bank}) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/banks/branch/namecontains/${bank}`,
      searchText,
    );
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};
